import React from 'react';
import { Picture } from 'formlabs-web-components/Media';
import { Link } from 'formlabs-web-components/Link';

import './MaterialCard.module.css';

const MaterialCard = ({
  image,
  image_alt,
  image_position,
  url,
  title,
  subtitle
}) => {
  return (
    <Link to={url}>
      <div styleName={`material-card ${image_position}`}>
        <Picture largeImage={image} alt={image_alt} />
        <div styleName="card-text">
          <div>
            <p styleName="title">{title}</p>
            <p styleName="subtitle">{subtitle}</p>
          </div>
          <i className="fl-arrow-right" />
        </div>
      </div>
    </Link>
  );
};

export default MaterialCard;
